import React, { Component } from 'react';
import { NavLink as RouteNavLink } from 'react-router-dom';
import { Nav, NavItem, NavLink } from 'shards-react';
import { compose } from 'redux';
import { connect } from 'react-redux';

const mapState = (state) => ({
  profile: state.firebase.profile,
});

class SidebarNavItems extends Component {
  render() {
    const managerNavs = [
      { label: 'Dashboard', to: '/dashboard/main', icon: 'dashboard' },
      { label: 'Search', to: '/dashboard/search', icon: 'search' },
      { label: 'Archive', to: '/dashboard/archive', icon: 'archive' },
      { label: 'Companies', to: '/dashboard/companies', icon: 'work' },
      {
        label: 'Agents',
        to: '/dashboard/agents',
        icon: 'supervised_user_circle',
      },
      { label: 'Sectors', to: '/dashboard/sectors', icon: 'list' },

      { label: 'Reports', to: '/dashboard/reports', icon: 'bar_chart' },
      {
        label: 'Notifications',
        to: '/dashboard/activities',
        icon: 'notification_important',
      },
      { label: 'Profile', to: '/dashboard/profile', icon: 'settings' },
      {
        label: 'Contact',
        to: '/dashboard/contactMessages',
        icon: 'contact_support',
      },
      // { label: 'Bug Report', to: '/dashboard/bugReport', icon: 'bug_report' },
      { label: 'Help', to: '/dashboard/help', icon: 'help' },
    ];

    const adminNavs = [];

    const agentItems = [
      { label: 'Dashboard', to: '/dashboard/main', icon: 'dashboard' },
      { label: 'Search', to: '/dashboard/search', icon: 'search' },
      { label: 'Archive', to: '/dashboard/archive', icon: 'archive' },
      { label: 'Companies', to: '/dashboard/companies', icon: 'work' },
      {
        label: 'Notifications',
        to: '/dashboard/activities',
        icon: 'notification_important',
      },
      { label: 'Profile', to: '/dashboard/profile', icon: 'settings' },
      {
        label: 'Contact',
        to: '/dashboard/contactMessages',
        icon: 'contact_support',
      },
      // { label: 'Bug Report', to: '/dashboard/bugReport', icon: 'bug_report' },
      { label: 'Help', to: '/dashboard/help', icon: 'help' },
    ];

    const items = [
      { label: 'Dashboard', to: '/dashboard/main', icon: 'dashboard' },
      {
        label: 'Notifications',
        to: '/dashboard/activities',
        icon: 'notification_important',
      },
      { label: 'Profile', to: '/dashboard/profile', icon: 'settings' },
      { label: 'Contact', to: '/dashboard/contact', icon: 'contact_support' },
      { label: 'Bug Report', to: '/dashboard/bugReport', icon: 'bug_report' },
      { label: 'Help', to: '/dashboard/help', icon: 'help' },
    ];

    const tagentItems = [
      { label: 'Dashboard', to: '/dashboard/main', icon: 'dashboard' },
      { label: 'Search', to: '/dashboard/search', icon: 'search' },
      { label: 'Archive', to: '/dashboard/archive', icon: 'archive' },
      { label: 'Companies', to: '/dashboard/companies', icon: 'work' },
      {
        label: 'Notifications',
        to: '/dashboard/activities',
        icon: 'notification_important',
      },
      { label: 'Profile', to: '/dashboard/profile', icon: 'settings' },
      {
        label: 'Contact',
        to: '/dashboard/contactMessages',
        icon: 'contact_support',
      },
      // { label: 'Bug Report', to: '/dashboard/bugReport', icon: 'bug_report' },
      { label: 'Help', to: '/dashboard/help', icon: 'help' },
    ];
    return (
      <div className='nav-wrapper'>
        <Nav className='nav--no-borders flex-column'>
          {this.props.profile.role === 'admin'
            ? adminNavs.map((item, idx) => (
                <NavItem key={idx}>
                  <NavLink tag={RouteNavLink} to={item.to}>
                    {<i className='material-icons'>{item.icon}</i>}
                    {item.label && <span>{item.label}</span>}
                  </NavLink>
                </NavItem>
              ))
            : ''}

          {this.props.profile.role === 'agent'
            ? agentItems.map((item, idx) => (
                <NavItem key={idx}>
                  <NavLink tag={RouteNavLink} to={item.to}>
                    {<i className='material-icons'>{item.icon}</i>}
                    {item.label && <span>{item.label}</span>}
                  </NavLink>
                </NavItem>
              ))
            : ''}
          {this.props.profile.role === 'temp-agent'
            ? tagentItems.map((item, idx) => (
                <NavItem key={idx}>
                  <NavLink tag={RouteNavLink} to={item.to}>
                    {<i className='material-icons'>{item.icon}</i>}
                    {item.label && <span>{item.label}</span>}
                  </NavLink>
                </NavItem>
              ))
            : ''}
          {this.props.profile.role === 'manager'
            ? managerNavs.map((item, idx) => (
                <NavItem key={idx}>
                  <NavLink tag={RouteNavLink} to={item.to}>
                    {<i className='material-icons'>{item.icon}</i>}
                    {item.label && <span>{item.label}</span>}
                  </NavLink>
                </NavItem>
              ))
            : ''}
          {this.props.profile.role === 'complainant'
            ? items.map((item, idx) => (
                <NavItem key={idx}>
                  <NavLink tag={RouteNavLink} to={item.to}>
                    {<i className='material-icons'>{item.icon}</i>}
                    {item.label && <span>{item.label}</span>}
                  </NavLink>
                </NavItem>
              ))
            : ''}
        </Nav>
      </div>
    );
  }
}
export default compose(connect(mapState, null))(SidebarNavItems);
